const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.lumayachting.com/api";

const MEDIA_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

export function mediaUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//i.test(pathOrUrl) || pathOrUrl.startsWith("data:")) {
    return pathOrUrl;
  }
  const normalized = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${MEDIA_ORIGIN}${normalized}`;
}

/**
 * Maps an image path to its thumbnail variant by naming convention:
 * "photo.jpg" -> "photo-thumb.webp" (same folder). Thumbs are generated by
 * server/scripts/generate-thumbs.js and by the admin upload endpoint.
 * External/absolute URLs and data URIs are returned untouched. Always pair
 * the resulting <img> with an onError fallback to the original image.
 */
export function thumbVariant(pathOrUrl) {
  if (!pathOrUrl || typeof pathOrUrl !== "string") return pathOrUrl;
  if (/^https?:\/\//i.test(pathOrUrl) || pathOrUrl.startsWith("data:")) {
    return pathOrUrl;
  }
  if (pathOrUrl.endsWith("-thumb.webp")) return pathOrUrl;
  if (!/\.(jpe?g|png|webp)$/i.test(pathOrUrl)) return pathOrUrl;
  return pathOrUrl.replace(/\.(jpe?g|png|webp)$/i, "-thumb.webp");
}

/** Small/cheap image for listing cards. */
export function pickYachtCardImage(yacht) {
  const large = pickYachtHeroImage(yacht);
  if (!large) return null;
  return mediaUrl(thumbVariant(stripOrigin(large)));
}

/** Full-size image (page heroes, and onError fallback for cards). */
export function pickYachtHeroImage(yacht) {
  if (!yacht) return null;
  if (yacht.heroImage) return mediaUrl(yacht.heroImage);
  const ext = Array.isArray(yacht.galleryExterior)
    ? yacht.galleryExterior[0]
    : null;
  if (ext?.large) return mediaUrl(ext.large);
  if (ext?.thumb) return mediaUrl(ext.thumb);
  if (Array.isArray(yacht.images) && yacht.images.length > 0) {
    return mediaUrl(yacht.images[0]);
  }
  return null;
}

function stripOrigin(url) {
  if (typeof url === "string" && url.startsWith(MEDIA_ORIGIN)) {
    return url.slice(MEDIA_ORIGIN.length);
  }
  return url;
}

/**
 * onError handler for card <img> elements: swaps a missing thumb for the
 * original full-size image (once, to avoid loops).
 */
export function cardImageFallback(yacht) {
  return (e) => {
    const fallback = pickYachtHeroImage(yacht);
    if (fallback && e.currentTarget.src !== fallback) {
      e.currentTarget.src = fallback;
    }
  };
}
